export function uploadReplacer(key: string, value: unknown) {
    if(key === "debug" ) return undefined
    return value
}